// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.i-am-looking-for {
    line-height: 14px;
    .iam-looking-for-header {
      letter-spacing: 0.5px;
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
      font-weight: bold;
      color: ${(props) => props.theme.colors.BLACK};
      margin-bottom: 24px;
      line-height: 26px;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        line-height: 20px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs16};
        margin-bottom: 16px;
      }
    }
    .looking-for-text-wrapper {
      font-size: 16px;
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      @media ${(props) => props.theme.mediaQuery.mediumMax} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      }
    }
    .match-link-box-body {
      line-height: 40px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        line-height: 32px;
        margin-bottom: 20px;
        margin-left: 6px;
      }
    }
  }
`;
